import { findAllProductWeight , createProductWeight, editProductWeight} from '../../_services/product_weight.service';

export const findProductWeightEvent = async () => {    
    let res = await findAllProductWeight();
    return res;
}

export const createProductWeightEvent = async (uuid_product,kilo,meter) => {   
    if(! uuid_product) throw new Error('No hay producto especificado');

    const body={
        uuid_product,
        kilo,
        meter
    }
    
    let res = await createProductWeight(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}

export const editProductWeightEvent = async (body) => {
    
    let res = await editProductWeight(body);
    if(! res.ok) throw new Error(res.error);
    return res;
}